import { _ } from "../../../../core/polyglot/polyglot.js";
import AccessRight from "./AccessRight.js";

let instance;

/**
 * TODO: write documentation
 */
export default class ReadOnlyAccessRight extends AccessRight {
	isReadOnly() {
		return true;
	}

	getLabel() {
		return _("Read");
	}

	static getType() {
		return "Viewer";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
